import React, {Component} from 'react'
import './uk.scss'
import {baiduTongJI, checkPhone} from "../../api/utils"
import api from "../../api/api"
import Footer from "../components/footer"
class Uk extends Component {
	state={
		name:'',
		mobile:'',
		city:'',
		intended_major:'',
		education:'',
		in_country:''
	}
	submit=async ()=>{
		let {name,mobile,city,intended_major,education,in_country}=this.state
		if (!name){
			layer.msg('姓名不能为空！')
			return
		}
		if (!checkPhone(mobile)){
			layer.msg('手机号格式不正确！')
			return
		}
		let res=await api.post('/form/study-abroad',{name,mobile,city,intended_major,education,in_country},true)
		this.setState({
			name:'',
			mobile:'',
			city:'',
			intended_major:'',
			education:'',
			in_country:''
		})
		layer.msg('提交成功')
		// console.log(res)
	}
	setValue=(key,val)=>{
		this.setState({
			[key]:val
		})
	}
	initSwiper=()=>{
		let slidesPerView=4
		if ($(window).width()<=768){
			slidesPerView=1
		}
		this.mySwiper = new Swiper('.mcuk_anli', {
			loop: true,
			slidesPerView:slidesPerView,
			spaceBetween:20,
			autoplay:true,
			pagination: {
				el: '.mcuk_pagination',
			},
			navigation: {
				nextEl: '.mcuk_next',
				prevEl: '.mcuk_prev',
			},
		})
	}
	openbaidusq=()=>{
		$('#nb_invite_ok').click()
	}
	componentDidMount() {
		document.getElementById('root').style.paddingTop=0
		document.getElementsByTagName('body')[0].style.setProperty("padding-top","0px","important")
		this.initSwiper()
		// baiduTongJI()
	}
	render() {
		return (
			<div>
				<div className={'uk'}>
					<div className={'ukbanWrap'}>
						<img className={'ukban'} src={require('../../static/images/ukBanner1.jpg')} alt=""/>
						<img className={'uklogo'} src={require('../../static/images/phoneLogo.png')} alt=""/>
					</div>
					<div className={'ukCenter'}>
						<div className={'ukModule'}>
							<div className={'ukTitle'}>
								What is 美丞
							</div>
							<div className={'ukPtext'}>
								美丞出国留学，专注英国G5名校申请，留学规划、背景提升、学术提升、离境服务等一站式服务，为您订制属于您自己的个性化留学方案。
							</div>
						</div>
						<div className={'ukModule'}>
							<div className={'ukTitle'}>
								名校来访
							</div>
							<div className={'ukLaiFang'}>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang1.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>剑桥大学招生官亲临“把关”</div>
									</div>
								</div>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang2.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>G5英国顶尖名校招生官与学生会面</div>
									</div>
								</div>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang3.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>2021世界名校公益在线联播活动</div>
									</div>
								</div>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang4.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>剑桥大学中国遴选中心储英项目新闻说明会</div>
									</div>
								</div>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang5.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>2019剑桥大学暑期PBL研学团</div>
									</div>
								</div>
								<div className={'ukLaiFangItem'}>
									<div className={'ukLaiFangItemBox'}>
										<div className={'ukImgBox'}>
											<img className={'ukLaiFangItemImg'} src={require('../../static/images/ukLaiFang6.jpg')} alt=""/>
										</div>
										<div className={'ukLaiFangItemText'}>2019“储英工程”新生开学典礼</div>
									</div>
								</div>
							</div>
						</div>
						<div className={'ukModule'}>
							<div className={'ukTitle'}>
								世界名校中国英才遴选工程
							</div>
							<div className={'ukPtext'}>
								世界名校中国英才遴选工程（China Excellence Identification Scheme，简称CEIS）是安生教育科学研究院和以英国剑桥大学为首的多所国际顶尖大学的官方合作项目，一个遴选在中国就读国家课程和部分国际课程的优秀高中学生进入世界著名大学接受一流本科教育的非盈利性项目。美丞留学荣幸作为AST考试的报名中心。
								<br/><br/>
								截至目前，已有近2000多名学子成功通过 CEIS 入读世界名校。随着该项目的发展，将有更多全球知名学府加入。
							</div>
							<div className={'ukJianqiao'}>
								<div className={'ukJianqiaoWrap ukImgBox'}>
									<img className={'ukJianqiaoImg'} src={require('../../static/images/ukJianqiao1.jpg')} alt=""/>
								</div>
								<div className={'ukJianqiaoWrap ukImgBox'}>
									<img className={'ukJianqiaoImg'} src={require('../../static/images/ukJianqiao2.jpg')} alt=""/>
								</div>
							</div>
						</div>
						<div className={'ukModule ukYouShiModule'}>
							<div className={'ukTitle'}>
								英国留学的优势
							</div>
							<div className={'ukYoushi'}>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										稳定的社会环境
									</div>
									<div className={'ukYoushiText'}>
										英国是全世界治安最好的国家之一，首先，枪支管理，要比美国还有大部分的欧洲国家严格很多， 尤其在1997年议会通过禁止私人持有枪支的法案后，可以说，英国算得上是一个禁枪国家了，枪支犯罪非常零星。
									</div>
								</div>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										学制短，总费用低
									</div>
									<div className={'ukYoushiText'}>
										英国大学本科一般都是3年制（苏格兰地区四年），授课型硕士一年，研究型硕士两年，而其他国家的硕士一般都需要2-3年，所以选择去英国读书，无形中节约了金钱和时间。 且近年来英镑汇率逐年降低，留学费用也相对降低不少。
									</div>
								</div>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										文凭国际认可
									</div>
									<div className={'ukYoushiText'}>
										英国有超过90所的大学和50多所高等教育学院。英国政府设置教评委员会，定期对所有的大学及同级学院做教学与学术研究的调查，且全面公开评鉴报告，因此，英国的学位在国际上广受承认和推崇。
									</div>
								</div>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										优质的教育水平
									</div>
									<div className={'ukYoushiText'}>
										英国的教育制度历史悠久、素以正统高素质的教学质量、严谨的学风、完备的体制闻名世界；科研方面，英国获得过90多次诺贝尔奖，传媒和商科专业在国际上占有重要地位；英国的时装及奢侈品在世界上也久负盛名。
									</div>
								</div>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										深厚的文化底蕴
									</div>
									<div className={'ukYoushiText'}>
										英国是英语的发源地，同时也是工业文明的发祥地，英国拥有令人羡慕的灿烂文化和艺术，它的音乐、剧院、电影、文学、时装无疑都可以使来此学习的海外学生充分地领略和享受完全不同于中国的文化氛围。
									</div>
								</div>
								<div className={'ukYoushiItem'}>
									<div className={'ukYoushiItemTitle'}>
										对国际生的政策利好
									</div>
									<div className={'ukYoushiText'}>
										英国政府多年来一直积极致力于在海外国家推广其优质的教育，鼓励各国学生来英国学习各种课程。拟提高留学生人数超30%，工作签政策进一步确定将于2021年落地，移民环境愈发宽松，且国民医疗和教育预算均大幅提高。
									</div>
								</div>
							</div>
						</div>
						<div className={'ukModule'}>
							<div className={'ukTitle'}>
								成功案例
							</div>
							<div className={'mcuk_anli  swiper-container'}>
								<div className={'ukAnlli swiper-wrapper'}>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli1.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											C同学 IELTS 6.5 爱丁堡大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli2.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											C同学 IELTS 6.5 杜伦大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli3.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											C同学 IELTS 7.0 华威大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli4.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											D同学 IELTS 7.0 曼彻斯特大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli5.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											J同学 IELTS 6.5 南安大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli6.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											L同学 IELTS 7.0 杜伦大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli7.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											Y同学 IELTS 7.0 帝国理工大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli8.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											Z同学 IELTS 6.5 杜伦大学
										</div>
									</div>
									<div className={'ukAnliItem swiper-slide'}>
										<div className={'ukAnliImgbox ukImgBox'}>
											<img className={'ukAnliImg'} src={require('../../static/images/ukAnli9.jpg')} alt=""/>
										</div>
										<div className={'ukAnliText'}>
											Z同学 TOEFL 109 利兹大学
										</div>
									</div>
								</div>
								<div className="mcuk_pagination swiper-pagination"></div>
								<div className="mcuk_prev swiper-button-prev"></div>
								<div className="mcuk_next swiper-button-next"></div>
							</div>
						</div>
						<div className={'ukModule ukP40 ukNoBg'}>
							<div className={'ukTitle'}>
								英国G5名校
							</div>
							<div className={'ukMingXiao'}>
								<div className={'ukMingxiaoTop'}>
									<div className={'ukMingxiaoJianJie'}>
										<div className={'ukMingxiaoJianJieTop'}>
											<img className={'ukMingxiaoImg'} src={require('../../static/images/ukMingxiao1.jpg')} alt=""/>
											<div className={'ukMingxiaoJianJieBox'}>
												<div className={'ukMingxiaoName'}>
													剑桥大学<span className={'ukMingxiaoPaiMing'}>院校排名：1</span>
												</div>
												<div className={'ukMingxiaoEnName'}>
													University of Cambridge
												</div>
												<div className={'ukMingxiaoAddress'}>
													<div className={'ukMingxiaoAddressItem'}>
														所在地：<span>英国剑桥</span>
													</div>
													<div className={'ukMingxiaoAddressItem'}>
														建校时间：<span>1209年</span>
													</div>
												</div>
											</div>
										</div>
										<div className={'ukMingxiaoJianJieBottom'}>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												留学总费用：13662英镑
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												录取比例：15.7%
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												学校性质：公立
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoLike'}>
										<div className={'ukMingxiaoCard ukMingxiaoCardLike'}>
											<div className={'ukMingxiaoCardTitle'}>剑桥大学更喜欢这样的学生</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													对所申请专业热爱、以及愿为自己的热爱付出的决心
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoInfo'}>
									<div className={'ukMingxiaoInfoItem1'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>院校介绍</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													剑桥大学（University of Cambridge；勋衔：Cantab），是一所世界顶尖的公立研究型大学，采用书院联邦制，其与牛津大学并称为牛剑，是罗素大学集团成员，被誉为“金三角名校”和“G5超级精英大学”。剑桥大学是英语世界中第二古老的大学。 <br/><br/>
													八百多年的校史汇聚了艾萨克·牛顿、开尔文、霍金、达尔文、马歇尔、华罗庚等科学巨匠，克伦威尔、尼赫鲁、李光耀等政治人物以及罗伯特·沃波尔（首任）在内的15位英国首相。
												</div>
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoInfoItem2'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>学院推荐</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													三一学院、国王学院、圣约翰学院、基督学院、丘吉尔学院
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoApply'} onClick={this.openbaidusq}>详询申请方案</div>
							</div>
							<div className={'ukMingXiao'}>
								<div className={'ukMingxiaoTop'}>
									<div className={'ukMingxiaoJianJie'}>
										<div className={'ukMingxiaoJianJieTop'}>
											<img className={'ukMingxiaoImg'} src={require('../../static/images/ukMingxiao2.jpg')} alt=""/>
											<div className={'ukMingxiaoJianJieBox'}>
												<div className={'ukMingxiaoName'}>
													牛津大学<span className={'ukMingxiaoPaiMing'}>院校排名：2</span>
												</div>
												<div className={'ukMingxiaoEnName'}>
													University of Oxford
												</div>
												<div className={'ukMingxiaoAddress'}>
													<div className={'ukMingxiaoAddressItem'}>
														所在地：<span>英国牛津</span>
													</div>
													<div className={'ukMingxiaoAddressItem'}>
														建校时间：<span>1096年</span>
													</div>
												</div>
											</div>
										</div>
										<div className={'ukMingxiaoJianJieBottom'}>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												留学总费用：16545英镑
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												录取比例：9.6%
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												学校性质：公立
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoLike'}>
										<div className={'ukMingxiaoCard ukMingxiaoCardLike'}>
											<div className={'ukMingxiaoCardTitle'}>牛津大学更喜欢这样的学生</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													优秀的学术水平
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													娴熟的写作、沟通能力
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													具有学以致用的能力
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoInfo'}>
									<div className={'ukMingxiaoInfoItem1'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>院校介绍</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													牛津大学（University of Oxford），简称“牛津”（Oxford），世界顶尖的公立研究型大学，采用书院联邦制。其与剑桥大学并称为牛剑，是罗素大学集团成员，被誉为“金三角名校”和“G5超级精英大学”。 <br/><br/>
													牛津大学是英语世界中最古老的大学，也是世界上现存第二古老的高等教育机构。该校涌现了一批引领时代的科学巨匠，培养了大量开创纪元的艺术大师、国家元首，其中包括28位英国首相及数十位世界各国元首、政商界领袖。
												</div>
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoInfoItem2'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>学院推荐</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													万灵学院、贝利奥尔学院、布雷齐诺斯学院、基督教堂学院、圣约翰学院
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoApply'} onClick={this.openbaidusq}>详询申请方案</div>
							</div>
							<div className={'ukMingXiao'}>
								<div className={'ukMingxiaoTop'}>
									<div className={'ukMingxiaoJianJie'}>
										<div className={'ukMingxiaoJianJieTop'}>
											<img className={'ukMingxiaoImg'} src={require('../../static/images/ukMingxiao3.jpg')} alt=""/>
											<div className={'ukMingxiaoJianJieBox'}>
												<div className={'ukMingxiaoName'}>
													帝国理工学院<span className={'ukMingxiaoPaiMing'}>院校排名：3</span>
												</div>
												<div className={'ukMingxiaoEnName'}>
													Imperial College London
												</div>
												<div className={'ukMingxiaoAddress'}>
													<div className={'ukMingxiaoAddressItem'}>
														所在地：<span>英国伦敦</span>
													</div>
													<div className={'ukMingxiaoAddressItem'}>
														建校时间：<span>1907年</span>
													</div>
												</div>
											</div>
										</div>
										<div className={'ukMingxiaoJianJieBottom'}>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												留学总费用：25500英镑
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												录取比例：8.1%
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												学校性质：公立
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoLike'}>
										<div className={'ukMingxiaoCard ukMingxiaoCardLike'}>
											<div className={'ukMingxiaoCardTitle'}>帝国理工学院更喜欢这样的学生</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													领导能力、有趣、活力
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													偏爱术有专攻类型
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													头脑灵活，具有独特的人格魅力
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoInfo'}>
									<div className={'ukMingxiaoInfoItem1'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>院校介绍</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													帝国理工学院（Imperial College London），世界顶尖公立研究型大学，在国际学术界有着顶级声望，是世界最具创新力的大学之一。
													<br/><br/>
													帝国理工学院是英国罗素大学集团、欧洲研究型大学联盟、国际科技大学联盟、全球大学校长论坛成员，与牛津大学、剑桥大学、伦敦大学学院、伦敦政治经济学院等校并称为金三角名校和G5超级精英大学。学院校友中，有14位诺贝尔奖得主  、3位菲尔兹奖得主。
												</div>
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoInfoItem2'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>学院推荐</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													工程学院、医学院、自然科学学院、商学院
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoApply'} onClick={this.openbaidusq}>详询申请方案</div>
							</div>
							<div className={'ukMingXiao'}>
								<div className={'ukMingxiaoTop'}>
									<div className={'ukMingxiaoJianJie'}>
										<div className={'ukMingxiaoJianJieTop'}>
											<img className={'ukMingxiaoImg'} src={require('../../static/images/ukMingxiao4.jpg')} alt=""/>
											<div className={'ukMingxiaoJianJieBox'}>
												<div className={'ukMingxiaoName'}>
													伦敦大学学院<span className={'ukMingxiaoPaiMing'}>院校排名：4</span>
												</div>
												<div className={'ukMingxiaoEnName'}>
													University College London
												</div>
												<div className={'ukMingxiaoAddress'}>
													<div className={'ukMingxiaoAddressItem'}>所在地：<span>英国剑桥</span> </div>
													<div className={'ukMingxiaoAddressItem'}>建校时间：<span>1826年</span></div>
												</div>
											</div>
										</div>
										<div className={'ukMingxiaoJianJieBottom'}>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												留学总费用：14750英镑
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												录取比例：10.6%
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												学校性质：公立
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoLike'}>
										<div className={'ukMingxiaoCard ukMingxiaoCardLike'}>
											<div className={'ukMingxiaoCardTitle'}>伦敦大学学院更喜欢这样的学生</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													头脑灵活、起到领导作用的潜力
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													优秀的学术水平
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													具有学以致用的能力
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoInfo'}>
									<div className={'ukMingxiaoInfoItem1'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>院校介绍</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													伦敦大学学院（University College London），简称UCL，是世界顶尖公立研究型大学，在多个大学排行榜中高居世界前十 ，为伦敦大学创校学院、罗素大学集团和欧洲研究型大学联盟创始成员，被誉为金三角名校和G5超级精英大学。
													<br/><br/>
													UCL培养了35位诺贝尔奖得主、3位菲尔兹奖得主及各领域菁英 ，包括光纤之父高锟，电话之父亚历山大·贝尔，DNA发现者弗朗西斯·克里克，核化学之父奥托·哈恩等。
												</div>
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoInfoItem2'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>学院推荐</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													医学院、脑科学学院、人文与艺术学院、历史与社会科学学院、法学院
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoApply'} onClick={this.openbaidusq}>详询申请方案</div>
							</div>
							<div className={'ukMingXiao'}>
								<div className={'ukMingxiaoTop'}>
									<div className={'ukMingxiaoJianJie'}>
										<div className={'ukMingxiaoJianJieTop'}>
											<img className={'ukMingxiaoImg'} src={require('../../static/images/ukMingxiao5.jpg')} alt=""/>
											<div className={'ukMingxiaoJianJieBox'}>
												<div className={'ukMingxiaoName'}>
													伦敦政治经济学院<span className={'ukMingxiaoPaiMing'}>院校排名：5</span>
												</div>
												<div className={'ukMingxiaoEnName'}>
													University of Cambridge
												</div>
												<div className={'ukMingxiaoAddress'}>
													<div className={'ukMingxiaoAddressItem'}>所在地：<span>英国伦敦</span> </div>
													<div className={'ukMingxiaoAddressItem'}>建校时间：<span>1895年</span></div>
												</div>
											</div>
										</div>
										<div className={'ukMingxiaoJianJieBottom'}>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												留学总费用：16392英镑
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												录取比例：15.6%
											</div>
											<div className={'ukMingxiaoJianJieBottomItem'}>
												学校性质：公立
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoLike'}>
										<div className={'ukMingxiaoCard ukMingxiaoCardLike'}>
											<div className={'ukMingxiaoCardTitle'}>伦敦政治经济学院更喜欢这样的学生</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													娴熟的写作、沟通能力
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													杰出的领导素质
												</div>
												<div className={'ukMingxiaoCardContentItem'}>
													<span className={'ukMingxiaoCardContentDian'}>●</span>
													拥有特别的气质或品质
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoInfo'}>
									<div className={'ukMingxiaoInfoItem1'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>院校介绍</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													伦敦政治经济学院（The London School of Economics and Political Science），简称伦敦政经（LSE），1895年创立于英国伦敦，是享誉全球的顶尖公立研究型大学，为伦敦大学联盟成员和罗素大学集团成员 ，被誉为金三角名校和G5超级精英大学。
													<br/><br/>
													LSE是一所专注于社会科学研究的大学，在政商界享有卓越口碑。截至2016年，校友中诞生了18位诺贝尔奖得主（囊括了所有诺贝尔经济学奖得主的17%）、55位国家元首或政府首脑、31名英国下议院议员及42名上议院议员。
												</div>
											</div>
										</div>
									</div>
									<div className={'ukMingxiaoInfoItem2'}>
										<div className={'ukMingxiaoCard'}>
											<div className={'ukMingxiaoCardTitle'}>学院推荐</div>
											<div className={'ukMingxiaoCardContent'}>
												<div className={'ukMingxiaoCardContentItem'}>
													会计与金融专业、经济学、金融专业、管理学、政治学
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={'ukMingxiaoApply'} onClick={this.openbaidusq}>详询申请方案</div>
							</div>
						</div>
						<div className={'ukModule ukNoBg'} id={'ukform'}>
							<div className={'ukTitle'}>
								免费留学评估
							</div>
							<div className={'ukForm'}>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>姓名 <span>*</span> </div>
									<input className={'ukInp'} value={this.state.name} onChange={(e)=>{this.setValue('name',e.target.value)}} type="text"/>
								</div>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>手机 <span>*</span> </div>
									<input className={'ukInp'} value={this.state.mobile} onChange={(e)=>{this.setValue('mobile',e.target.value)}} type="text"/>
								</div>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>所在城市</div>
									<input className={'ukInp'} value={this.state.city} onChange={(e)=>{this.setValue('city',e.target.value)}} type="text"/>
								</div>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>意向专业</div>
									<input className={'ukInp'} value={this.state.intended_major} onChange={(e)=>{this.setValue('intended_major',e.target.value)}} type="text"/>
								</div>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>教育阶段</div>
									<select className={'ukInp'} value={this.state.education}
									        onChange={(e)=>{
										        e.persist();
										        this.setValue('education',e.target.value)
									        }} name="" id="">
										<option value="" disabled={true}>请选择</option>
										<option value="高中">高中</option>
										<option value="大专">大专</option>
										<option value="本科">本科</option>
										<option value="硕士">硕士</option>
									</select>
								</div>
								<div className={'ukFormItem'}>
									<div className={'ukFormLabel'}>意向国家</div>
									<select value={this.state.in_country}  onChange={(e,v)=>{
										e.persist();
										this.setValue('in_country',e.target.value)
									}} className={'ukInp'} name="" id="">
										<option value="" disabled={true}>请选择</option>
										<option value="美国">美国</option>
										<option value="英国">英国</option>
										<option value="加拿大">加拿大</option>
										<option value="澳洲">澳洲</option>
										<option value="新西兰">新西兰</option>
										<option value="香港">香港</option>
										<option value="新加披">新加披</option>
										<option value="其他">其他</option>
									</select>
								</div>
							</div>
							<div className={'ukFormButton'} onClick={this.submit}>
								提交
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Uk